import { useState } from "react";
import { Box, Button, Icon, chakra } from "@chakra-ui/react";
import { ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";

const ChakraMotionDiv = chakra(motion.div);

type SubstitutionItem = {
  key: string;
  label: string;
  value: string;
};

export interface KYDDataButtonSectionProps {
  substitutions: SubstitutionItem[];
  onAddData: (key: string) => void;
  isDisabled?: boolean;
}

export default function KYDDataButtonSection({
  substitutions,
  onAddData,
  isDisabled = false,
}: KYDDataButtonSectionProps) {
  const [showItems, setShowItems] = useState(false);

  const containerVariants = {
    visible: {
      transition: {
        staggerChildren: 0.05,
      },
    },
    hidden: {},
  };

  const itemVariants = {
    hidden: { opacity: 0, y: -10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 300,
        damping: 20,
      },
    },
  };

  if (substitutions.length === 0) {
    return null;
  }

  return (
    <Box display="block" bg="white" height={showItems ? "100px" : "56px"}>
      <ChakraMotionDiv
        variants={containerVariants}
        initial="hidden"
        position="absolute"
        top={0}
        left={0}
        animate={showItems ? "visible" : "hidden"}
        style={{
          display: "flex",
          backgroundColor: showItems ? "white" : "transparent",
          zIndex: showItems ? 1000 : 0,
          flexWrap: "wrap",
          gap: "8px",
          height: showItems ? "fit-content" : "56px",
          // overflow: "hidden",
        }}
        px={0}
        py={3}
      >
        <Button
          onClick={() => setShowItems(!showItems)}
          fontWeight="400"
          py={4}
          px={4}
          size="sm"
          variant="unstyled"
          borderRadius="md"
          isDisabled={isDisabled}
          sx={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "white",
            border: "1px solid #C3DDFB",
            transition: "all 0.2s ease-in-out",
            boxShadow: showItems
              ? "0px 0px 5px 0px #C3DDFB"
              : "0px 0px 10px 0px #C3DDFB",
            _hover: {
              borderColor: "#4B6AF1",
              boxShadow:
                "0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A",
            },
          }}
        >
          Add Data
          <Icon as={showItems ? ChevronLeftIcon : ChevronRightIcon} />
        </Button>
        {substitutions.map(({ label, key }) => (
          <motion.div key={key} variants={itemVariants}>
            <Button
              isDisabled={!showItems || isDisabled}
              py={4}
              px={4}
              onClick={() => onAddData(key)}
              size="sm"
              fontWeight="400"
              borderRadius="md"
              sx={{
                position: "relative",
                background: "white",
                border: "1px solid #C3DDFB",
                transition: "all 0.2s ease-in-out",
                _hover: {
                  borderColor: "#4B6AF1",
                  boxShadow:
                    "0px 2px 4px -1px #0000000F, 0px 4px 6px -1px #0000001A",
                },
              }}
            >
              {label}
            </Button>
          </motion.div>
        ))}
      </ChakraMotionDiv>
    </Box>
  );
}
